import { z } from "zod/v4";

export const coachVerificationStatusSchema = z.enum(["pending", "verified", "rejected"]);

export const coachVerificationItemSchema = z.object({
	area: z.string(),
	avatarUrl: z.string().nullable(),
	bio: z.string().nullable(),
	decidedAt: z.string().nullable(),
	displayName: z.string().nullable(),
	headline: z.string().nullable(),
	note: z.string().nullable(),
	requestedAt: z.string(),
	status: coachVerificationStatusSchema,
	userId: z.string(),
});

/** The answer to a decision: where the request now stands, not the coach. */
export const coachVerificationDecisionSchema = z.object({
	decidedAt: z.string().nullable(),
	note: z.string().nullable(),
	requestedAt: z.string(),
	status: coachVerificationStatusSchema,
});

export const coachVerificationListResponseSchema = z.object({
	items: z.array(coachVerificationItemSchema),
	total: z.number(),
});

export type CoachVerificationStatus = z.infer<typeof coachVerificationStatusSchema>;
export type CoachVerificationItem = z.infer<typeof coachVerificationItemSchema>;
export type CoachVerificationDecision = z.infer<typeof coachVerificationDecisionSchema>;
export type CoachVerificationListResponse = z.infer<typeof coachVerificationListResponseSchema>;
